import { useNavigate, useParams } from 'react-router-dom';

import { Navbar } from '@/components/admin/general/Navbar';
import { adminNavItems } from '@/data/admin/general/navigationData';
import { useAuth } from '@/hooks/useAuth';

import { EmployeeDetailContent } from './EmployeeDetailContent';

export const EmployeeDetailPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { employeeId } = useParams<{ employeeId: string }>();

  return (
    <div className="min-h-screen ">
      <Navbar
        navItems={adminNavItems}
        userName={user?.name || 'Usuario'}
        pageTitle="Perfil de Empleado"
        section="Empleados"
      />

      <EmployeeDetailContent
        employeeId={employeeId}
        mode="admin"
        onBack={() => void navigate('/empleados/directorio')}
        backLabel="Volver al directorio de empleados"
      />
    </div>
  );
};
